module.exports = __webpack_public_path__ + "4dff412163e0f0e9acc4e7a594f74beb.png";